// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nvwc-3-dialog[data-v-b96372ae] {\n  --dialog-max-inline-size: 609px;\n}\n.safari-notification-empty-state[data-v-b96372ae] {\n  display: block;\n  margin: 24px;\n}\n.safari-notification-description[data-v-b96372ae] {\n  margin-block: 0;\n}\n", ""]);
// Exports
module.exports = exports;
